import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultTextAreaField } from 'src/components/mui-overrides/Textarea';

interface Props {
  disabled?: boolean;
}

export const SecurityDetailsTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  return (
    <DefaultTextAreaField
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.securityinformation.fields.securityDetails.label')}
      fieldName="descriptions.securityDetails"
      formik={formik}
      placeholder={t('dashboard.assets.addedit.investment.securityinformation.fields.securityDetails.placeholder')}
    />
  );
};
